import { SiGithub, SiLinkerd } from "@icons-pack/react-simple-icons";
import { ExternalLink, FileUser, Icon } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminText from "src/components/common/AdminText";
import GitCommitText from "src/components/common/GitCommitText";
import { useIsDarkTheme } from "src/components/common/useIsDarkTheme";
import Dashboard from "src/components/dashboard/Dashboard";
import ResponsiveColorWidget from "src/components/debug/ResponsiveColorWidget";
import ContextWidget from "src/components/widgets/ContextWidget";
import {
  setCurrentDashboardMode,
  setCurrentStackListId,
  setlastClickedItemId,
} from "src/store/dashboardSlice";
import { naruhoneStyles } from "src/styles/naruhoneStyles";
import StackIcon from "tech-stack-icons";

const LionelHomePage = () => {
  let dashdata = [
    {
      id: "item-4",
      y: 0,
      x: 0,
      w: 1,
      h: 1,
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    },
    { id: "pachinko", y: 1, x: 0, w: 1, h: 1, type: "pachinko" },
    // {"id":"item-5","y":3,"x":4,"w":3,"h":2,"type":"calendar","content":"a"},
    { id: "item-aaa", y: 0, x: 6, w: 3, h: 4, type: "chat" },
  ];

  const [dashboardData, setDashboardData] = useState(dashdata);
  const cacheHomePageData = useSelector(
    (state) => state.dashboard.gridHomePage
  );
  const cacheHomePageDataStatus = useSelector(
    (state) => state.dashboard.gridHomePageStatus
  );
  const dispatch = useDispatch();
  const isDark = useIsDarkTheme();

  const videoRef = useRef(null);
  const contextWidgetRef = useRef(null);

  useEffect(() => {
    dispatch(setCurrentDashboardMode("view"));
    dispatch(setCurrentStackListId("homepagepublic"));
  }, [dispatch]);
  useEffect(() => {
    if (cacheHomePageData) {
      let initialItemId = cacheHomePageData?.dashboardData?.find(
        (item) => item?.type === "text"
      )?.id;
      if (initialItemId !== null) {
        dispatch(setlastClickedItemId(initialItemId));
      }
    }
  }, [cacheHomePageData]);

  const styleTechStack = ``;
  // const styleTechStack = `rounded-md p-2 ${isDark ? "bg-gray-700": "bg-gray-100"}`;

  //const workStyle = `rounded-md p-2 ${isDark ? "bg-gray-700" : "bg-gray-100"}`;
  const workStyle = `rounded-lg p-4 lg:p-8`;

  const workExpHeaderStyle = `${naruhoneStyles.h2Text} font-bold text-md text-lg lg:text-2xl`;
  const workExpDescription = `${naruhoneStyles.pText} text-white text-sm max-w-3xl lg:text-xl`;

  return (
    <div className="">
      <div className="hero lg:h-1/2 mb-8">
        <div className="hero-content flex-col lg:flex-row gap-16">
          <div className="avatar">
            <div className="ring-primary ring-offset-base-100 w-48 md:w-60 rounded-xl ring-2 ring-offset-2">
              {/* <img src="shika.JPG" /> */}
              <video
                ref={videoRef}
                src="/video/naruhoneavatar2com.mp4"
                autoPlay
                muted
                loop
                preload="auto"
                playsInline
                className="rounded-xl shadow-lg max-w-md object-cover w-full h-full"
                onCanPlay={() => videoRef.current?.play()}
              />
            </div>
          </div>
          <div>
            <header className="leading-relaxed text-slate-400 antialiased selection:bg-teal-300 selection:text-teal-900">
              <h1 className={`${naruhoneStyles.h1Text} text-5xl`}>
                Lionel Kayasith
              </h1>
              <h2 className={`${naruhoneStyles.h2Text} text-lg mt-2`}>
                Full-Stack Developer
              </h2>
              <AdminText className="text-teal-300 font-medium" />
              <p
                className={`${naruhoneStyles.pText} mt-2 max-w-2xl leading-normal font-sans`}
              >
                Welcome to my portfolio website! I am a Full-stack developer
                based in Canberra, Australia🦘
                <br />
                <br />I built this interactive dashboard to show myself to the
                internet in a fun way, as well as <i>demonstrate</i> my skills
                across the many areas a full-stack developer would cover — from
                frontend UI to backend architecture. Explore the widgets, learn
                a bit about me and get a feel for what I can build 😀
              </p>
              <div className="block lg:hidden pt-4">
                I recommend viewing on computer for best experience
              </div>
              <div className="pt-4 flex gap-4">
                <a
                  href="https://github.com/PockyG"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GitHub"
                >
                  <button className="w-12 rounded-full bg-primary h-12 center flex items-center justify-center hover:bg-secondary transition-colors duration-300 text-white">
                    <SiGithub className="w-8 h-8" />
                  </button>
                </a>
                {/* <a
                  href="https://www.linkedin.com/in/lionel-kayasith-28977810b/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <button className="w-12 rounded-full bg-primary h-12 center flex items-center justify-center hover:bg-secondary transition-colors duration-300 text-white">
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.27c-.97 0-1.75-.79-1.75-1.76s.78-1.76 1.75-1.76 1.75.79 1.75 1.76-.78 1.76-1.75 1.76zm13.5 11.27h-3v-5.6c0-1.34-.03-3.07-1.87-3.07-1.87 0-2.16 1.46-2.16 2.97v5.7h-3v-10h2.89v1.36h.04c.4-.75 1.37-1.54 2.82-1.54 3.01 0 3.57 1.98 3.57 4.56v5.62z" />
                    </svg>
                  </button>
                </a> */}
                <a
                  href="/resume/Lionel-Kayasith-2025.pdf"
                  download="Lionel-Kayasith-2025.pdf"
                  title="Download Resume"
                >
                  <button className="w-12 rounded-full bg-primary h-12 center flex items-center justify-center hover:bg-secondary transition-colors duration-300">
                    <FileUser className="w-8 h-8 text-white" />
                  </button>
                </a>
              </div>
            </header>
          </div>
        </div>
      </div>

      {cacheHomePageDataStatus !== "succeeded" && (
        <div
          className={`w-full min-w-[1100px] mx-auto relative rounded-xl bg-[#0F172A]`}
        >
          <div className="skeleton h-[700px] w-full bg-[#0F172A]"></div>
        </div>
      )}
      {cacheHomePageDataStatus === "succeeded" && (
        <>
          <div className="relative">
            <div ref={contextWidgetRef}
              className="sticky top-0 h-[250px] z-10 bg-[#0F172A] 
            card border-2 border-slate-300 sm:hidden"
            >
              <ContextWidget containerRef={contextWidgetRef}/>
            </div>
            <div className={`animate-fadein`}>
              <Dashboard items={cacheHomePageData.dashboardData} />
            </div>
          </div>
        </>
      )}
      <div className="flex justify-center items-center w-full h-full">
        <div className="max-w-[1400px] p-8">
          <h2 className={`${naruhoneStyles.h1Text} text-2xl lg:text-4xl mt-16`}>
            Work experience
          </h2>
          <div className={`${workStyle} bg-primary mt-2`}>
            <div className="flex justify-between ">
              <h2 className={workExpHeaderStyle}>
                IT Consultant (Developer) @ SRA
              </h2>
              <h2 className={workExpHeaderStyle}>2021-2024</h2>
            </div>
          </div>
          <div className={`rounded-lg p-8 bg-neutral mt-2`}>
            <div className="flex-col">
              <div className="pb-2 mr-2 mb-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="sra-svg"
                  width="70"
                  height="28.009"
                  viewBox="0 0 70 28.009"
                >
                  <path
                    className="sra"
                    d="M-414.612-2873.219l-.063-.016a5.3,5.3,0,0,1-1.358-.66l-.1-.068-.045-.031a5.7,5.7,0,0,1-1.093-1.012,5.974,5.974,0,0,1-1.507-3.951v-.026a6,6,0,0,1,3.785-5.556c.129-.056.634-.248.859-.312l3.7-1.043a.245.245,0,0,1,.208.019.246.246,0,0,1,.119.172.313.313,0,0,1-.15.266c-.08.059-.188.135-.311.227l-.009.007a5.146,5.146,0,0,0-1.9,5.359,5.146,5.146,0,0,0,4.194,3.841.365.365,0,0,1,.2.091.263.263,0,0,1,0,.3,5.777,5.777,0,0,1-4.815,2.661h-.009A5.668,5.668,0,0,1-414.612-2873.219Zm-19.3.076V-2890.3a5.8,5.8,0,0,0-.038-.662,4.059,4.059,0,0,0-.329-1.223,3.518,3.518,0,0,0-.711-1.028c-.092-.089-.215-.172-.215-.311v-.006a.189.189,0,0,1,.007-.05.281.281,0,0,1,.019-.041.2.2,0,0,1,.172-.1h1.95a6.006,6.006,0,0,1,4.246,1.759,6,6,0,0,1,1.756,4.247v14.57Zm33.478,0a6,6,0,0,1-6-6v-9.07c0-.09,0-.176-.01-.262a5.106,5.106,0,0,0-4.6-4.9.215.215,0,0,1-.194-.209.18.18,0,0,1,.041-.123.239.239,0,0,1,.132-.079,12.025,12.025,0,0,1,2.205-.213c5.566,0,9.279,3.631,9.279,9.55v7.874a5.6,5.6,0,0,0,.037.661,4.134,4.134,0,0,0,.329,1.224,3.547,3.547,0,0,0,.713,1.028c.085.089.2.175.2.314,0,.186-.2.2-.2.2Zm-54.2-.127a.445.445,0,0,1-.135-.343v-6.612a.271.271,0,0,1,.06-.2.27.27,0,0,1,.186-.1c.173,0,.225.14.265.286.007.033.017.066.026.1a8.489,8.489,0,0,0,.667,1.871,7.246,7.246,0,0,0,.578,1,8.639,8.639,0,0,0,5.163,3.581l.166.047a.236.236,0,0,1,.2.194.236.236,0,0,1-.121.247.736.736,0,0,1-.284.054h-6.457A.446.446,0,0,1-454.632-2873.273Zm10.967-.055h-.049a.2.2,0,0,1-.172-.194.247.247,0,0,1,.009-.058v-.01a.308.308,0,0,1,.021-.046,3.421,3.421,0,0,0,.563-2.678,3.423,3.423,0,0,0-1.579-2.237l-.788-.455-6-3.463a6,6,0,0,1-3.279-6.236,6,6,0,0,1,4.909-5.054h.063a.2.2,0,0,1,.17.2.2.2,0,0,1-.008.056v.01a.216.216,0,0,1-.022.046,3.425,3.425,0,0,0-.569,2.681,3.424,3.424,0,0,0,1.579,2.24l.788.455,6,3.458,0,0a6,6,0,0,1,3.28,6.237,6,6,0,0,1-4.909,5.054Zm27.452-16.766a2.571,2.571,0,0,1,2.571-2.572,2.572,2.572,0,0,1,2.572,2.572,2.572,2.572,0,0,1-2.572,2.572A2.572,2.572,0,0,1-416.214-2890.094Zm-9.673-.594a3.164,3.164,0,0,1,3.164-3.164,3.164,3.164,0,0,1,3.164,3.164,3.164,3.164,0,0,1-3.164,3.164A3.164,3.164,0,0,1-425.887-2890.688Zm-18.92-.592a2.572,2.572,0,0,1,2.572-2.572,2.572,2.572,0,0,1,2.572,2.572,2.572,2.572,0,0,1-2.572,2.571A2.572,2.572,0,0,1-444.807-2891.281Z"
                    transform="translate(468.305 2900.966)"
                    fill={`#ffffff`}
                  ></path>
                  <path
                    className="slash"
                    d="M11.522,0,0,27.817H2.069L13.592,0Z"
                    fill="#f4004e"
                  ></path>
                </svg>
              </div>

              <div className="flex text-slate-400 text-2xl align-center">
                <a href="https://www.sra.com.au/" target="_blank">
                  <div className="flex">
                    <ExternalLink className="text-white mr-4 mt-1" />
                    <p>sra.com.au</p>
                  </div>
                </a>
              </div>

              <p className={workExpDescription}>
                Worked as a developer in a team to maintain and deliver new
                features for multiple existing Australian government
                projects/services, mostly working in Java, Spring, and SQL
                database. Navigated complex legacy codebases, used agile
                development and writing up well-documented board items,
                following inhouse procedures, and supporting and being supported
                by the team, to deliver features for satisfied clients and
                achieving target KPIs.
              </p>
            </div>
            <div className="flex mt-2">
              <div className={styleTechStack}>
                {[
                  { title: "Java", icon: "java" },
                  { title: "Spring", icon: "spring" },
                  { title: "HTML", icon: "html5" },
                  { title: "Azure dev ops", icon: "azure" },
                  { title: "Atlassian suite", icon: "atlassian" },
                  { title: "Jira", icon: "jira" },
                  { title: "JavaScript", icon: "js" },
                  { title: "Typescript", icon: "typescript" },
                  { title: "Amazon web services", icon: "aws" },
                  {
                    title: "Microsoft SQL Server Management Studio",
                    icon: "microsoft",
                  },
                  { title: "Postman", icon: "postman" },
                  { title: "Github", icon: "github" },
                ].map((ic, index) => {
                  return (
                    <span key={ic.icon + index} title={ic.title}>
                      <StackIcon
                        className="w-8 h-8 mr-2"
                        name={ic.icon.toLowerCase()}
                        grayscale={isDark ? true : false}
                      />
                    </span>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="relative overflow-hidden group">
            <div className="flex w-full  aspect-[3/1] md:h-64">
              <img
                src="recreg.PNG"
                alt="recreg"
                className="flex-1 object-cover h-full"
              />
              <img
                src="anreu.PNG"
                alt="recreg"
                className="flex-1 object-cover h-full"
              />
              <img
                src="govawarda.jpg"
                alt="recreg"
                className="flex-1 object-cover h-full"
              />
            </div>
            <div className="absolute inset-0 bg-primary opacity-100 mix-blend-color transition duration-500 ease-in-out group-hover:opacity-0"></div>
          </div>
          <div className={`${workStyle} bg-primary mt-8`}>
            <div className="flex justify-between ">
              <h2 className={workExpHeaderStyle}>
                Flutter Mobile Developer @ Wotsay
              </h2>
              <h2 className={workExpHeaderStyle}>2019-2021</h2>
            </div>
          </div>
          <div className={`${workStyle} bg-neutral mt-2`}>
            <div className="flex-col">
              <p className={workExpDescription}>
                Sole front-end developer for a startup mobile itinerary planning
                app project, building and releasing a cross-platform Flutter app
                for both Android and iOS. Delivered a full product despite
                minimal initial design assets, and absence of senior technical
                mentorship, handling end-to-end development, testing and
                release.
              </p>
              <div className="flex mt-2">
                <div className={styleTechStack}>
                  {[
                    { title: "Flutter", icon: "flutter" },
                    { title: "Dart", icon: "dart" },
                    { title: "Figma", icon: "figma" },
                    { title: "Android", icon: "android" },
                    { title: "Safari", icon: "safari" },
                    { title: "Jira", icon: "jira" },
                    { title: "Postman", icon: "postman" },
                    { title: "Github", icon: "github" },
                  ].map((ic, index) => {
                    return (
                      <span key={ic.icon + index} title={ic.title}>
                        <StackIcon
                          className="w-8 h-8 mr-2"
                          name={ic.icon.toLowerCase()}
                          grayscale={isDark ? true : false}
                        />
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="relative overflow-hidden group">
            <div className="flex w-full aspect-[6/1]">
              <img
                src="wslogin.png"
                alt="wslogin"
                className="flex-1 object-cover h-full"
              />
              <img
                src="wsday.PNG"
                alt="wsday"
                className="flex-1 object-cover h-full"
              />
              <img
                src="wsevents.png"
                alt="wsevents"
                className="flex-1 object-cover h-full"
              />
              <img
                src="addwotitin.PNG"
                alt="addwotitin"
                className="flex-1 object-cover h-full"
              />
              <img
                src="wstags.png"
                alt="wstags"
                className="flex-1 object-cover h-full"
              />
              <img
                src="wsstyle.PNG"
                alt="wsstyle"
                className="flex-1 object-cover h-full"
              />
            </div>
            <div className="absolute inset-0 bg-primary opacity-100 mix-blend-color transition duration-500 ease-in-out group-hover:opacity-0"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LionelHomePage;
